/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriveFileResource } from '../models/DriveFileResource';
import type { DriveFilesResource } from '../models/DriveFilesResource';
import type { DriveRequest } from '../models/DriveRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * Rechercher des fichiers (V1)
     * Utiliser `GET /v2/drive` (filtres par `entity_type` / `entity_id` / `tag` / auteur).
     * @param requestBody
     * @returns any Paginated set of `DriveFilesResource`
     * @throws ApiError
     */
    public driveSearchFiles(
        requestBody?: DriveRequest,
    ): CancelablePromise<{
        data: Array<DriveFilesResource>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/drive/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * @deprecated
     * Deposer un fichier (V1)
     * Utiliser `POST /v2/drive` (rattachements et tags explicites).
     * @param requestBody
     * @returns string
     * @throws ApiError
     */
    public driveUpload(
        requestBody?: DriveRequest,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/drive/upload',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * @deprecated
     * Projets ayant au moins un fichier (V1)
     * Utiliser `GET /v2/drive/entities?entity_type=project`.
     * @returns string
     * @throws ApiError
     */
    public driveListProjectUseDrive(): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/drive/listProjectUseDrive',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * @deprecated
     * Supprimer des fichiers (V1)
     * Utiliser `DELETE /v2/drive/{id}`, un fichier a la fois.
     * @param fileIds
     * @returns any
     * @throws ApiError
     */
    public driveDeleteFiles(
        fileIds: Array<string>,
    ): CancelablePromise<{
        message: string;
        deleted_files: Array<string>;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/drive',
            query: {
                'file_ids': fileIds,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Lister les fichiers de l'entreprise
     * Les filtres se cumulent. `entity_type` seul renvoie tous les fichiers rattaches a ce type d'element (projet, devis, facture, intervention, commande fournisseur) ; avec `entity_id`, ceux d'un element precis (`entity_id` exige `entity_type`). Un filtre vide est ignore.
     *
     * 30 fichiers par page (`page`), du plus recent au plus ancien. Chaque fichier porte une `url` de telechargement valable 30 minutes, a ouvrir en `GET` uniquement.
     * @param entityType
     * @param entityId
     * @param tag
     * @param authorType
     * @param authorId
     * @param page
     * @returns any Paginated set of `DriveFileResource`
     * @throws ApiError
     */
    public driveIndex(
        entityType?: 'project' | 'quote' | 'invoice' | 'intervention' | 'bc_fourn',
        entityId?: number | null,
        tag?: string | null,
        authorType?: 'personnel' | 'client' | 'user',
        authorId?: number | null,
        page?: number | null,
    ): CancelablePromise<{
        data: Array<DriveFileResource>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/drive',
            query: {
                'entity_type': entityType,
                'entity_id': entityId,
                'tag': tag,
                'author_type': authorType,
                'author_id': authorId,
                'page': page,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Deposer un fichier
     * Envoi en `multipart/form-data`. `display_name` vaut par defaut le nom du fichier envoye. Vous pouvez rattacher le fichier a des elements des le depot avec `attachments` (ex. `[{"entity_type": "project", "entity_id": 123}]`) et lui ajouter des `tags` (ex. `["public"]`) ; les deux restent modifiables ensuite.
     * @param formData
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveStore(
        formData: {
            file: Blob;
            display_name?: string | null;
            tags?: any[] | null;
            attachments?: any[] | null;
        },
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/drive',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Elements ayant au moins un fichier
     * Renvoie les identifiants de tous les elements du type demande qui ont au moins un fichier. Pratique pour signaler la presence de fichiers dans une liste sans charger les fichiers eux-memes.
     * @param entityType
     * @returns string
     * @throws ApiError
     */
    public driveListEntitiesWithFiles(
        entityType: 'project' | 'quote' | 'invoice' | 'intervention' | 'bc_fourn',
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/drive/entities',
            query: {
                'entity_type': entityType,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un fichier
     * Avec ses rattachements, ses tags et une `url` de telechargement valable 30 minutes.
     * @param id
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveShow(
        id: string,
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/drive/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Supprimer un fichier
     * Supprime le fichier et tous ses rattachements. Irreversible.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public driveDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/drive/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Rattacher un fichier a un element
     * Un fichier peut etre rattache a plusieurs elements (un projet et un devis, par exemple). Rattacher deux fois le meme element est sans effet.
     * @param id
     * @param requestBody
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveAddAttachment(
        id: string,
        requestBody: {
            entity_type: 'project' | 'quote' | 'invoice' | 'intervention' | 'bc_fourn';
            entity_id: number;
        },
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/drive/{id}/attachments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detacher un fichier d'un element
     * Ne supprime pas le fichier, seulement le lien.
     * @param id
     * @param entityType
     * @param entityId
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveRemoveAttachment(
        id: string,
        entityType: string,
        entityId: number,
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/drive/{id}/attachments',
            path: {
                'id': id,
            },
            query: {
                'entity_type': entityType,
                'entity_id': entityId,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Ajouter un tag a un fichier
     * Tag libre de 50 caracteres maximum. Certains tags ont un sens particulier : `public` (visible par le client dans son espace), `portfolio` (mis en avant), `pv-reception` (proces-verbal d'intervention). Ajouter un tag deja present est sans effet.
     * @param id
     * @param requestBody
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveAddTag(
        id: string,
        requestBody: {
            tag: string;
        },
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/drive/{id}/tags',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Retirer un tag d'un fichier
     * Sans effet si le fichier ne portait pas ce tag.
     * @param id
     * @param tag
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public driveRemoveTag(
        id: string,
        tag: string,
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/drive/{id}/tags/{tag}',
            path: {
                'id': id,
                'tag': tag,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
